import { render, staticRenderFns } from "./CustomSection.vue?vue&type=template&id=33d01898&"
import script from "./CustomSection.vue?vue&type=script&lang=js&"
export * from "./CustomSection.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports